var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { css, html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { GGOBaseComponent } from '../ggo.base.component.js';
let CheckboxComponent = class CheckboxComponent extends GGOBaseComponent {
    static { this.properties = {
        label: { type: String },
        checked: { type: Boolean },
        disabled: { type: Boolean },
        onclick: { type: Function },
    }; }
    static get styles() {
        return [
            ...super.styles,
            css `
        .ggo-checkbox {
          cursor: pointer;
          font-size: 1rem;
        }
        .slds-checkbox__input:focus+.slds-checkbox__label .slds-checkbox_faux {
          border-color: #1b96ff;
          box-shadow: #1b96ff 0px 0px 3px 0px;
        }
      `,
        ];
    }
    constructor() {
        super();
        this.label = '';
        this.disabled = false;
        this.checked = false;
    }
    _handleClick(e) {
        this.checked = !this.checked;
        this.dispatchEvent(new CustomEvent('changed', { detail: this.checked }));
    }
    render() {
        const id = Math.random().toString(36).substring(8);
        return html `
      <div class="slds-form-element">
        <div class="slds-form-element__control">
          <div class="slds-checkbox">
            <input
              type="checkbox"
              @change=${this._handleClick}
              id="${id}"
              name="${id}"
              class="slds-checkbox__input"
              ?disabled=${this.disabled}
              ?checked=${this.checked}
            />
            <label class="slds-checkbox__label ggo-checkbox" for="${id}">
              <span class="slds-checkbox_faux"></span>
              <span class="slds-form-element__label"><slot></slot></span>
            </label>
          </div>
        </div>
      </div>
    `;
    }
};
CheckboxComponent = __decorate([
    customElement('ggo-checkbox')
], CheckboxComponent);
export { CheckboxComponent };
